import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/primeng';
import { DatePipe } from '@angular/common';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MatDatepicker, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { FormControl } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-timesheet-rank',
  templateUrl: './timesheet-rank.component.html',
  styleUrls: ['./timesheet-rank.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})

export class TimesheetRankComponent implements OnInit {

  locationDD = [];
  locationOptions: SelectItem[];
  roleDD = [];
  report: any;
  reportingList = [];
  reportingToDD = [];
  rollOptions: SelectItem[];
  deptDD = [];
  deptOptions: SelectItem[];
  reportingToOptions: SelectItem[];
  currentDate = new Date();
  reportCols = [
    { field: 'rank', header: 'Rank' },
    { field: 'userImg', header: '' },
    { field: 'userName', header: 'User' },
    { field: 'role', header: 'Role' },
    { field: 'startTime', header: 'Start Time' },
    { field: 'onTime', header: 'On Time' },
    { field: 'eightHoursCount', header: 'Eight Hours' },
    { field: 'totalWorkhours', header: 'Work Hours' },
    { field: 'totalPresentDays', header: 'Present Days' },
    { field: 'totalAbsentDays', header: 'Absent Days' },
    { field: 'department', header: 'Department' },
    { field: 'reportingTo', header: 'Reporter' },
    { field: 'reportingToImg', header: 'Reporter' },
    { field: 'location', header: 'Location' },
    // { field: 'userMail', header: 'Email' },
  ];
  tabIndex: number;
  projectName: string;
  totalResourceRecords: any;
  selectbydate = new Date();
  reportsList = [];
  reportDate = '';
  watchLists = [];
  formDate = new FormControl(moment());
  totalRecords: number;
  totalTimesheetRecords: number;
  totalWatchlistRecords: number;

  constructor(private queryInterface: QueryInterface,
    private parseService: ParseService,
    private hardCodedValues: HardCodedValues,
    private spinner: NgxSpinnerService,
    private getReportingToService: GetReportingToService
  ) {

  }

  async ngOnInit() {
    await this.getTimeSheetReport(new Date());
    this.getLocation();
    this.getDepartment();
    this.getRollOption();
    this.getReportingTo();
    this.tabChange(0);
  }

  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = this.bindDropDown(res);
    });
  }

  async getLocation() {
    await this.getReportingToService.getLocation().then(res => {
      this.locationOptions = this.bindDropDown(res);
    });
  }

  bindDropDown(array) {
    const dropDownItem = [];
    if (array != undefined) {
      array.forEach(a => {
        dropDownItem.push({ label: a.label, value: a.label });
      });
    }
    return dropDownItem;
  }

  getRollOption() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        result.push({ label: roleList.name, id: roleList.objectId });
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
    });
  }


  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = this.bindDropDown(res);
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  tabChange(index): void {
    if (index == 0) {
      this.tabIndex = 0;
      this.totalTimesheetRecords = this.reportsList.length;
    }
    if (index == 1) {
      this.tabIndex = 1;
      this.totalWatchlistRecords = this.watchLists.length;
    }
  }


  async getTimeSheetReport(date): Promise<any> {
    this.spinner.show();
    let filterDate = new Date(date);
    let condition = [];
    let type = '';
    let reports = [];
    this.reportsList = [];
    this.watchLists = [];
    let datePipe = new DatePipe('en-US');
    let reportDate = datePipe.transform(filterDate, 'MM/dd/yyyy');
    condition = [
      { condition: 'limit', value: 10000000 },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'user.profile' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'ascending', value: 'rank' },
      { condition: 'equalTo', field: 'reportDate', value: reportDate },
    ];
    type = 'TimeSheetReport';

    await this.queryInterface.executeQuery(this.parseService, type, condition).then(async results => {
      let datePipe = new DatePipe('en-US');
      this.reportDate = datePipe.transform(new Date(date), 'dd MMM yyyy');
      if (results.length > 0) {
        results.forEach(element => {
          let profile = element.get('user').get('profile');
          let reporting = element.get('reportingTo');
          let reportDetails = element.get('reportDetails');
          reports.push({
            rank: element.get('rank'),
            userName: profile.get('firstName') + ' ' + profile.get('lastName'),
            userImg: profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url,
            userMail: profile.get('officialInfo').officialEmail,
            reportingTo: reporting.get('firstName') + ' ' + reporting.get('lastName'),
            reportingToImg: reporting.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : reporting.get('profileImageInfo').url,
            role: reportDetails.role,
            department: reportDetails.department,
            location: reportDetails.location,
            startTime: reportDetails.startTime,
            onTime: reportDetails.onTime,
            eightHoursCount: reportDetails.hoursCount,
            totalWorkhours: reportDetails.workhours,
            totalPresentDays: reportDetails.presentDays,
            totalAbsentDays: reportDetails.absentDays
          });
        });
        this.reportsList = reports.sort(function (a, b) { return a.rank - b.rank; });
        this.watchLists = ((this.reportsList).slice(this.reportsList.length - 25)).reverse();
      }
      this.spinner.hide();
    });
  }

  chosenYearHandler(normalizedYear: Moment): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.year(normalizedYear.year());
    this.formDate.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.formDate.setValue(ctrlValue);
    let date = new Date(this.formDate.value);
    let filterDate = date.getMonth() == new Date().getMonth() ? new Date() : new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.filterReport(filterDate);
    datepicker.close();
  }

  filterReport(date): any {
    this.getTimeSheetReport(date);
  }

  onFilterTimesheet(event, dt): any {
    this.totalTimesheetRecords = event.filteredValue.length;
  }

  onFilterWatchlist(event, dt): any {
    this.totalWatchlistRecords = event.filteredValue.length;
  }

}